import Vue from 'vue'
import env from './env'
import { store } from '@/store'
import AgModal from '@/components/Web/Modal'
import AgSelect from '@/components/Modal/Select'
import AgCheckbox from '@/components/Modal/Checkbox'
import AgMessage from '@/components/Modal/Message'

const ModalClass = Vue.extend(AgModal)

function showModal (component, props, fullscreen, width, disableScroll) {
  return new Promise(resolve => {
    const body = document.body
    const modal = new ModalClass({
      store,
      propsData: {
        fullscreen,
        width: fullscreen ? null : width,
        disableScroll
      }
    })
    const done = event => {
      // Check if the modal element still exists and is a child of body before removing
      if (modal.$el && modal.$el.parentNode === body) {
        body.removeChild(modal.$el)
      }

      resolve(event)
    }

    if (typeof component === 'object') {
      modal.$slots.default = [
        modal.$createElement(component, {
          props,
          on: { done }
        })
      ]
    }

    modal.$on('done', done)
    modal.$mount()
    
    body.appendChild(modal.$el)
  })
}

function checkboxDialog (titleText, cancelText, items, selected) {
  return showModal(AgCheckbox, { titleText, cancelText, items, selected })
}

function actionDialog (titleText, cancelText, items) {
    return showModal(AgSelect, {titleText, cancelText, items})
}

function alertDialog (options) {
  return new Promise(resolve => {
    alert(options.message || options)

    resolve()
  })
}

function confirmDialog (options) {
  return new Promise(resolve => {
    resolve(confirm(options.message || options))
  })
}

function promptDialog (options, defaultText) {
  return new Promise(resolve => {
    resolve(prompt(options.message || options, options.defaultText || defaultText))
  })
}

function messageDialog (caption, text, icon) {
  return showModal(AgMessage, { caption, text, icon })
}

function componentDialog (component, data, fullscreen, width, disableScroll) {
  let max = Math.round(env.width - 30)

  return showModal(component, data, fullscreen, width > max ? max : width, disableScroll)
}

export default {
  action: actionDialog,
  alert: alertDialog,
  checkbox: checkboxDialog,
  confirm: confirmDialog,
  prompt: promptDialog,
  message: messageDialog,
  component: componentDialog
}